"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _GhostMarketNDSNeo3_instances, _GhostMarketNDSNeo3_network, _GhostMarketNDSNeo3_treatGhostMarketImage, _GhostMarketNDSNeo3_getUrlWithParams, _GhostMarketNDSNeo3_parse;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GhostMarketNDSNeo3 = void 0;
const axios_1 = __importDefault(require("axios"));
const query_string_1 = __importDefault(require("query-string"));
const RpcNDSNeo3_1 = require("./RpcNDSNeo3");
class GhostMarketNDSNeo3 extends RpcNDSNeo3_1.RpcNDSNeo3 {
    constructor(network) {
        super(network);
        _GhostMarketNDSNeo3_instances.add(this);
        _GhostMarketNDSNeo3_network.set(this, void 0);
        __classPrivateFieldSet(this, _GhostMarketNDSNeo3_network, network, "f");
    }
    getNftsByAddress({ address, size = 18, cursor }) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const url = __classPrivateFieldGet(this, _GhostMarketNDSNeo3_instances, "m", _GhostMarketNDSNeo3_getUrlWithParams).call(this, {
                size,
                owners: [address],
                cursor: cursor,
            });
            const { data } = yield axios_1.default.get(url);
            const nfts = (_a = data.assets) !== null && _a !== void 0 ? _a : [];
            return { nextCursor: data.next, items: nfts.map(__classPrivateFieldGet(this, _GhostMarketNDSNeo3_instances, "m", _GhostMarketNDSNeo3_parse).bind(this)) };
        });
    }
    getNft({ contractHash, tokenId }) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = __classPrivateFieldGet(this, _GhostMarketNDSNeo3_instances, "m", _GhostMarketNDSNeo3_getUrlWithParams).call(this, {
                contract: contractHash,
                tokenIds: [tokenId],
            });
            const { data } = yield axios_1.default.get(url);
            return __classPrivateFieldGet(this, _GhostMarketNDSNeo3_instances, "m", _GhostMarketNDSNeo3_parse).call(this, data.assets[0]);
        });
    }
}
exports.GhostMarketNDSNeo3 = GhostMarketNDSNeo3;
_GhostMarketNDSNeo3_network = new WeakMap(), _GhostMarketNDSNeo3_instances = new WeakSet(), _GhostMarketNDSNeo3_treatGhostMarketImage = function _GhostMarketNDSNeo3_treatGhostMarketImage(srcImage) {
    if (!srcImage) {
        return;
    }
    if (srcImage.startsWith('ipfs://')) {
        const splitImage = srcImage.split('/');
        const imageId = splitImage.slice(-2).join('/');
        return `https://ghostmarket.mypinata.cloud/ipfs/${imageId}`;
    }
    return srcImage;
}, _GhostMarketNDSNeo3_getUrlWithParams = function _GhostMarketNDSNeo3_getUrlWithParams(params) {
    const config = GhostMarketNDSNeo3.CONFIG_BY_NETWORK_ID[__classPrivateFieldGet(this, _GhostMarketNDSNeo3_network, "f").id];
    if (!config)
        throw new Error('GhostMarketNDSNeo3 does not support this network');
    const parameters = query_string_1.default.stringify(Object.assign({ chain: config.chain }, params), { arrayFormat: 'bracket' });
    return `${config.url}/assets?${parameters}`;
}, _GhostMarketNDSNeo3_parse = function _GhostMarketNDSNeo3_parse(data) {
    var _a, _b;
    const nftResponse = {
        collectionImage: __classPrivateFieldGet(this, _GhostMarketNDSNeo3_instances, "m", _GhostMarketNDSNeo3_treatGhostMarketImage).call(this, (_a = data.collection) === null || _a === void 0 ? void 0 : _a.logoUrl),
        id: data.tokenId,
        contractHash: data.contract.hash,
        symbol: data.contract.symbol,
        collectionName: (_b = data.collection) === null || _b === void 0 ? void 0 : _b.name,
        image: __classPrivateFieldGet(this, _GhostMarketNDSNeo3_instances, "m", _GhostMarketNDSNeo3_treatGhostMarketImage).call(this, data.metadata.mediaUri),
        isSVG: String(data.metadata.mediaType).includes('svg+xml'),
        name: data.metadata.name,
        creator: {
            address: data.creator.address,
            name: data.creator.offchainName,
        },
    };
    return nftResponse;
};
GhostMarketNDSNeo3.CONFIG_BY_NETWORK_ID = {
    mainnet: {
        url: 'https://api.ghostmarket.io/api/v2',
        chain: 'n3',
    },
    testnet: {
        url: 'https://api.ghostmarket.io/api/v2',
        chain: 'n3t',
    },
};
